import classnames from 'classnames';
import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SearchFormState } from '../../../store/reducers';
import { isMultiCity } from '../../../store/segments/selectors';
import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import { getHasPassengersErrors, getTotalPassengersCount } from '../../../store/passengers/selectors';
import { useForm } from 'react-final-form';
import { default as BaseButton } from '../../../../BaseComponents/Button';
import { CdnIcon } from '@shared/ui';

interface OwnProps {
	mode: 'icon' | 'text';
}

interface StateProps {
	isMultiCity: boolean;
	passengersCount: number;
}

type Props = OwnProps & StateProps;

const StartSearch = React.memo<Props>(props => {
	const { StartSearch: css } = useTheme('SearchForm');
	const { t } = useTranslation('SearchForm');
	const hasPassengersErrors = useSelector(getHasPassengersErrors);

	const { resumeValidation } = useForm();

	const {
		SearchForm: { proMode }
	} = useConfig();

	return (
		<div
			className={classnames(css.startSearch, {
				[css.startSearch_iconMode]: props.mode === 'icon',
				[css.startSearch_multiCity]: props.isMultiCity,
				[css.startSearch_advanced]: proMode
			})}
		>
			<BaseButton
				type="submit"
				variant="smallPrimary"
				data-test-id="search-submit"
				disabled={hasPassengersErrors}
				onClick={resumeValidation}
			>
				{props.mode === 'icon' ? <CdnIcon icon={'Action/Search'} /> : <span> {t('Search')} </span>}
			</BaseButton>
		</div>
	);
});

const mapStateToProps = (state: SearchFormState, props: OwnProps): Props => {
	return {
		...props,
		isMultiCity: isMultiCity(state),
		passengersCount: getTotalPassengersCount(state)
	};
};

export default connect(mapStateToProps)(StartSearch);
